import '@components/Logo/Logo.css';

import DidxlLogo from '@assets/svg/didxl_logo.svg';
import DidxlLogoBlack from '@assets/svg/didxl_logo_black.svg';

const LogoDark = ({ className }) => <DidxlLogoBlack className={className} />;
export const LogoLight = ({ className }) => <DidxlLogo className={className} />;

export default LogoDark;
